export default "__VITE_ASSET__899b0037__"